import EventPrice from "./EventPrice";
import EventAction from "./EventAction";
import {useAuth} from "../../../services/use-auth";

export default function EventHeader(
    {
        id,
        name,
        image,
        imageFile,
        paymentRequired,
        registrationRequired,
        isStarted,
        isFinished,
        isUserCheckedIn,
        isUserRegistered,
        isRegistrationAvailable,
        isSurveyAvailable,
        isInFavorite,
        prices,
        tickets,
        userTicket,
        eventDataUpdate,
        youtubeVideoId,
        isKeepVideoAfterFinish,
    }
) {
    const auth = useAuth();
    const imageSource = imageFile ?
        `/${imageFile.relativePath.replace(/^\//, '')}` :
        `/${image.replace(/^\//, '')}`;
    const isVideoShowAvailable = !!auth.user && !!youtubeVideoId && isStarted;
    const isShowYoutubeVideo = isVideoShowAvailable && (!isFinished || isKeepVideoAfterFinish);
    const isShowYoutubeChat = isVideoShowAvailable && isUserCheckedIn && !isFinished;
    const iframeStyle = {width: '100%', height: '100%'};

    return (
        <div className="conference-grid title-block">
            <div className="image-block">
                {
                    isShowYoutubeVideo ?
                        <iframe title={'conferenceVideo'} style={iframeStyle} src={`https://www.youtube.com/embed/${youtubeVideoId}?modestbranding=1`} frameBorder="0"
                                allow="autoplay; encrypted-media" allowFullScreen /> :
                        <img src={imageSource} className="img-fill" alt=""/>
                }
            </div>
            <div className="general-block flex-center">
                <div style={isShowYoutubeChat ? iframeStyle : {}}>
                    {
                        isShowYoutubeChat ?
                            <iframe allowFullScreen frameBorder="0" title={'conferenceChat'} style={iframeStyle}
                                    src={`https://www.youtube.com/live_chat?v=${youtubeVideoId}&embed_domain=${window.location.host}`}
                            /> :
                            <>
                                <h1>{ name }</h1>
                                <EventPrice
                                    paymentRequired={paymentRequired}
                                    isFinished={isFinished}
                                    prices={prices}
                                    tickets={tickets}
                                    userTicket={userTicket}
                                />
                                <EventAction
                                    id={id}
                                    registrationRequired={registrationRequired}
                                    isStarted={isStarted}
                                    isFinished={isFinished}
                                    isUserCheckedIn={isUserCheckedIn}
                                    isRegistrationAvailable={isRegistrationAvailable}
                                    isUserRegistered={isUserRegistered}
                                    isSurveyAvailable={isSurveyAvailable}
                                    isInFavorite={isInFavorite}
                                    eventDataUpdate={eventDataUpdate}
                                />
                            </>
                    }

                </div>
            </div>
        </div>
    )
}
